import React from "react";
import { useEffect, useState, useRef } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import { format } from 'date-fns';
import html2pdf from "html2pdf.js";
import commonLabels from "../../../common/labels/common_en.json";
import label from "../../labels/interviewProcess_en.json";
import {
  getExamslistByAdvertisementId,
  getAdvertisementsList,
  getSubjectlistByExamId
} from "../../../postExaminationProcessObjective/actions/postExaminationProcessObjectiveActions";
import {
  getQualifyingCandidatesList,
  printQualifyingCandidatesList,
} from "../../actions/interviewProcessActions";
import { getYearList, getAdvertisementlistByYear, getCheckQualifiedList, getFinalResultList } from "../../../common/actions/commonActions";
import { SET_QUALIFYING_CANDIDATES_LIST } from "../../../common/constants/ActionTypes";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const QualifyingReports = () => {
  const pdfRef = useRef(null);
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });
  const dispatch = useDispatch();
  const [selectedExam, setSelectedExam] = useState("");
  let [selectedAdvert, setSelectedAdvert] = useState(false);
  const [reloadItem, setReloadItem] = useState(true);
  const [saveButtonFlag, setSaveButtonFlag] = useState(true);
  const [stepName, setStepName] = useState("qualifyingReport");
  const [showCutoffTable, setShowCutoffTable] = useState(false);
  const [finalResultList, setFinalResultList] = useState([]);
  const [selectedFinalStatus, setSelectedFinalStatus] = useState("");
  const [showFinalTable, setShowFinalTable] = useState(false);
  const [selectedSubject, setSelectedSubject] = useState("");

  const session = JSON.parse(sessionStorage.getItem("session"));
  const date = new Date(); // Your date object here
  const formattedDate = format(date, 'MM/dd/yyyy');
  useEffect(() => {
    dispatch(getYearList());
    window.scrollTo(0, 0)
    setReloadItem(!reloadItem);
    dispatch({
      type: SET_QUALIFYING_CANDIDATES_LIST,
      payload: []
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let { examList, advertisementList, subjectList } = useSelector(
    (state) => state.postExamProcessObjectReducer,
    shallowEqual
  );

  let { yearList, allYearList, checkQualifiedList, finalResultData } = useSelector(
    (state) => state.common,
    shallowEqual
  );

  let { qualifyingCandidatesList } = useSelector(
    (state) => state.interviewProcessReducer,
    shallowEqual
  );

  const printQualifyingListPDF = () => {
    genPdf();
    //dispatch(printQualifyingCandidatesList(selectedExam));
  };
  const genPdf = () => {
    let headerDiv = '<div class="row d-flex flex-column align-items-center"><h5>' + commonLabels.MPSC + '</h5><h5>' + qualifyingCandidatesList.examName + '</h5><h5>' + commonLabels.QUALIFYING_CANDIDATES_REPORT + '</h5></div>';
    const htmlContent = document.createElement('div');
    htmlContent.innerHTML = headerDiv;
    htmlContent.innerHTML += pdfRef.current.innerHTML;


    const options = {
      margin: [0.8, 0.4, 0.8, 0.4],
      filename: 'Qualifying_Candidates_List_.pdf',
      image: { type: 'jpeg', quality: 0.95 },
      html2canvas: { scale: 3, dpi: 300, letterRendering: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait', compressPDF: true },
    };

    html2pdf()
      .from(htmlContent)
      .set(options)
      .toPdf()
      .get('pdf')
      .then((pdf) => {
        const totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);

          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();
          const textWidth = pdf.getStringUnitWidth(`${i}`) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const textX = pageWidth - textWidth - 1;
          const textY = 0.8;
          const currentDate = new Date();
          const formattedDate = currentDate.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
          }).split('/').join('/');
          const dateWidth = pdf.getStringUnitWidth(formattedDate) * pdf.internal.getFontSize() / pdf.internal.scaleFactor;
          const dateX = pageWidth - dateWidth;
          const dateY = 0.6;
          pdf.setFontSize(8);
          pdf.text(formattedDate, dateX, dateY);
          pdf.text(`Page No. ${i}`, dateX, textY)

          const ad = qualifyingCandidatesList.advertisementNo;
          const headerText = `Advertisement No. ${ad}`;
          const headerX = 0.4;
          const headerY = 0.6;

          pdf.setFontSize(8);
          pdf.text(headerText, headerX, headerY);
        }

        pdf.save(`Qualifying_Candidates_List_${selectedExam}.pdf`);

      });
  };


  const onExamChange = (ele) => {
    let selectedValue = ele;
    setSelectedExam(selectedValue);
    qualifyingCandidatesList.length = 0;
    selectedValue && dispatch(getQualifyingCandidatesList(selectedValue));
    setReloadItem(!reloadItem);
  };
  const onAdvertisementChange = (ele) => {
    let selectedValue = ele;
    setSelectedAdvert(selectedValue);
    setSelectedExam("");
    examList.length = 0;
    qualifyingCandidatesList.length = 0;
    selectedValue && dispatch(getExamslistByAdvertisementId(selectedValue));
    dispatch({
      type: SET_QUALIFYING_CANDIDATES_LIST,
      payload: []
    })
    setReloadItem(!reloadItem);
  };

  const onSelectYear = (ele) => {
    let selectedValue = ele;
    selectedValue && dispatch(getAdvertisementlistByYear(selectedValue));
    if (allYearList) {
      allYearList.length = 0
    }
    if (examList) {
      examList.length = 0;
    }

    setSaveButtonFlag(true);
    dispatch({
      type: SET_QUALIFYING_CANDIDATES_LIST,
      payload: []
    })
    setReloadItem(!reloadItem);
  };


  const handleShowQualified = () => {
    if (!selectedExam) {
      alert("Please select Exam");
      return;
    }

    if (!selectedSubject) {
      alert("Please select Subject");
      return;
    }

    dispatch(getCheckQualifiedList(selectedExam, selectedSubject)); //  pass subject

    setShowCutoffTable(true);
  };
  // const handleShowQualified = () => {
  //   if (!selectedExam) {
  //     alert("Please select Exam");
  //     return;
  //   }
  //   dispatch(getCheckQualifiedList(selectedExam));
  //   setShowCutoffTable(true);
  // };
  // const subjectHeaders =
  //   checkQualifiedList.length > 0
  //     ? Object.keys(checkQualifiedList[0].subjectMarks || {})
  //     : [];

  const subjectHeaders = React.useMemo(() => {
    if (!checkQualifiedList || checkQualifiedList.length === 0) return [];

    const subjectSet = new Set();

    checkQualifiedList.forEach((cand) => {
      if (cand.subjectMarks) {
        Object.keys(cand.subjectMarks).forEach((sub) =>
          subjectSet.add(sub)
        );
      }
    });

    return Array.from(subjectSet);
  }, [checkQualifiedList]);

  const handleShowFinalResult = () => {
    if (!selectedExam) {
      alert("Please select Exam");
      return;
    }

    // if (!selectedFinalStatus) {
    //   alert("Please select Status");
    //   return;
    // }

    dispatch(getFinalResultList(selectedExam, selectedFinalStatus));
    setShowFinalTable(true);
  };

  const onExamChangeCutoff = (value) => {
    setSelectedExam(value);
    setSelectedSubject("");

    if (value) {
      dispatch(getSubjectlistByExamId(value)); // load subjects
    }
  };
const downloadExcel = () => {
  const allCandidates =
    qualifyingCandidatesList?.postWiseCandidates?.flatMap(
      (post) =>
        (post.qualifiedCandidates || []).map((candidate) => ({
          postName: post.postName,
          ...candidate,
        }))
    ) || [];

  if (!allCandidates.length) {
    alert("No data available to download");
    return;
  }

  const data = allCandidates.map((e, i) => ({
    "Sr No": i + 1,
    "Post Name": e.postName || "-",
    "INT No": e.interviewNo || "-",
    "Application No": e.applicationId || "-",
    "Roll No": e.rollNo || "-",
    "Candidate Name": e.candidateName || "-",
    "Gender": e.gender || "-",
    "Status": e.status || "-",
  }));

  const worksheet = XLSX.utils.json_to_sheet(data);

  worksheet["!cols"] = Object.keys(data[0]).map((key) => ({
    wch: Math.max(
      key.length,
      ...data.map((row) =>
        row[key] ? row[key].toString().length : 10
      )
    ),
  }));

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Qualified List");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `Qualifying_Candidates_List_${selectedExam}.xlsx`);
};
  return (

    // <div className="dashboardContentArea">

    //   {/* TABS */}
    //   <ul className="nav nav-tabs mt-3">
    //     <li className="nav-item">
    //       <a
    //         href="#"
    //         className={
    //           stepName === "qualifyingReport"
    //             ? "nav-link active"
    //             : "nav-link bg-profile-tabs"
    //         }
    //         onClick={() => setStepName("qualifyingReport")}
    //       >
    //          Qualifying Result
    //       </a>
    //     </li>

    //     <li className="nav-item">
    //       <a
    //         href="#"
    //         className={
    //           stepName === "qualifyingCutoff"
    //             ? "nav-link active"
    //             : "nav-link bg-profile-tabs"
    //         }
    //         onClick={() => setStepName("qualifyingCutoff")}
    //       >
    //           Qualifying Result
    //       </a>
    //     </li>
    //   </ul>

    //   {/* TAB CONTENT */}
    //   <div className="tab-content border border-light p-3">

    //     {/* ================= TAB 1 : QUALIFYING REPORT ================= */}
    //     {stepName === "qualifyingReport" && (
    //       <>
    //         <div className="row dashboardCards">
    //           <div className="col-md-12">
    //             <form name="importForm" encType="multipart/form-data">
    //               <div className="form-group importFromSection">
    //                 <div className="row">

    //                   {/* YEAR */}
    //                   <div className="form-group col-md-2">
    //                     <label className="float-left">
    //                       {commonLabels.selectYear}
    //                       <span className="errorText">*</span>
    //                     </label>
    //                     <select
    //                       className="form-control"
    //                       name="selectedYear"
    //                       ref={register({ required: true })}
    //                       onChange={(e) => onSelectYear(e.target.value)}
    //                     >
    //                       <option value="">{commonLabels.COMBO_SELECT}</option>
    //                       {yearList?.map((yr, i) => (
    //                         <option key={i}>{yr}</option>
    //                       ))}
    //                     </select>
    //                   </div>

    //                   {/* ADVERTISEMENT */}
    //                   <div className="form-group col-md-5">
    //                     <label className="float-left">
    //                       {commonLabels.SelectAdvertNo}
    //                       <span className="errorText">*</span>
    //                     </label>
    //                     <select
    //                       className="form-control"
    //                       ref={register({ required: true })}
    //                       onChange={(e) => onAdvertisementChange(e.target.value)}
    //                     >
    //                       <option value="">{commonLabels.COMBO_SELECT}</option>
    //                       {allYearList
    //                         ?.filter(e => e.isActive && !e.isDeleted)
    //                         .map((el, i) => (
    //                           <option key={i} value={el.id}>
    //                             {`${el.advertisementNo}/${el.year} - ${el.name}`}
    //                           </option>
    //                         ))}
    //                     </select>
    //                   </div>

    //                   {/* EXAM */}
    //                   <div className="form-group col-md-4">
    //                     <label className="float-left">
    //                       {label.SelectExam}
    //                       <span className="errorText">*</span>
    //                     </label>
    //                     <select
    //                       className="form-control"
    //                       ref={register({ required: true })}
    //                       onChange={(e) => onExamChange(e.target.value)}
    //                     >
    //                       <option value="">{commonLabels.COMBO_SELECT}</option>
    //                       {examList
    //                         ?.filter(e => e.isActive && !e.isDeleted)
    //                         .map((el, i) => (
    //                           <option key={i} value={el.id}>{el.name}</option>
    //                         ))}
    //                     </select>
    //                   </div>

    //                 </div>
    //               </div>
    //             </form>
    //           </div>
    //         </div>

    //         {/* RESULT TABLE */}
    //         {qualifyingCandidatesList?.advertisementNo && (
    //           <>
    //             {(session.roleName === "superadmin" ||
    //               session.roleName === "secretary") && (
    //                 <div className="row">
    //                   <div className="col-md-12">
    //                     <button
    //                       className="btn btn-primary mb-2 float-right"
    //                       onClick={printQualifyingListPDF}
    //                     >
    //                       {commonLabels.BUTTON_PRINT}
    //                     </button>
    //                   </div>
    //                 </div>
    //               )}

    //             <div ref={pdfRef}>
    //               <table className="table">
    //                 <thead className="thead-light">
    //                   <tr>
    //                     <th>{label.SNo}</th>
    //                     <th>{label.INTNO}</th>
    //                     <th>{label.ROLLNO}</th>
    //                     <th>{label.CANDIDTESNAME}</th>
    //                     <th>{label.GENDER}</th>
    //                     <th>{label.STATUS}</th>
    //                   </tr>
    //                 </thead>
    //                 <tbody>
    //                   {qualifyingCandidatesList?.qualifiedCandidates?.map((e, i) => (
    //                     <tr key={i}>
    //                       <td>{i + 1}</td>
    //                       <td><strong>{e.interviewNo}</strong></td>
    //                       <td>{e.rollNo}</td>
    //                       <td>{e.candidateName}</td>
    //                       <td>{e.gender}</td>
    //                       <td><strong>{e.status}</strong></td>
    //                     </tr>
    //                   ))}
    //                 </tbody>
    //               </table>
    //             </div>
    //           </>
    //         )}
    //       </>
    //     )}

    //     {/* ================= TAB 2 : QUALIFYING CUT-OFF ================= */}
    //     {stepName === "qualifyingCutoff" && (
    //       <>
    //         {/* FILTER SECTION */}
    //         <div className="row dashboardCards">
    //           <div className="col-md-12">
    //             <div className="form-group importFromSection">
    //               <div className="row">

    //                 {/* YEAR */}
    //                 <div className="form-group col-md-2">
    //                   <label>
    //                     {commonLabels.selectYear}
    //                     <span className="errorText">*</span>
    //                   </label>
    //                   <select
    //                     className="form-control"
    //                     onChange={(e) => onSelectYear(e.target.value)}
    //                   >
    //                     <option value="">{commonLabels.COMBO_SELECT}</option>
    //                     {yearList?.map((yr, i) => (
    //                       <option key={i}>{yr}</option>
    //                     ))}
    //                   </select>
    //                 </div>

    //                 {/* ADVERTISEMENT */}
    //                 <div className="form-group col-md-5">
    //                   <label>
    //                     {commonLabels.SelectAdvertNo}
    //                     <span className="errorText">*</span>
    //                   </label>
    //                   <select
    //                     className="form-control"
    //                     onChange={(e) => onAdvertisementChange(e.target.value)}
    //                   >
    //                     <option value="">{commonLabels.COMBO_SELECT}</option>
    //                     {allYearList
    //                       ?.filter(e => e.isActive && !e.isDeleted)
    //                       .map((el, i) => (
    //                         <option key={i} value={el.id}>
    //                           {`${el.advertisementNo}/${el.year} - ${el.name}`}
    //                         </option>
    //                       ))}
    //                   </select>
    //                 </div>

    //                 {/* EXAM */}
    //                 <div className="form-group col-md-3">
    //                   <label>
    //                     {label.SelectExam}
    //                     <span className="errorText">*</span>
    //                   </label>
    //                   <select
    //                     className="form-control"
    //                     onChange={(e) => setSelectedExam(e.target.value)}
    //                   >
    //                     <option value="">{commonLabels.COMBO_SELECT}</option>
    //                     {examList
    //                       ?.filter(e => e.isActive && !e.isDeleted)
    //                       .map((el, i) => (
    //                         <option key={i} value={el.id}>{el.name}</option>
    //                       ))}
    //                   </select>
    //                 </div>

    //                 {/* SHOW BUTTON */}

    //                 <div className="form-group col-md-2">
    //                   <label>&nbsp;</label>
    //                   <button
    //                     type="button"
    //                     className="btn btn-primary w-100"
    //                     onClick={() => setShowCutoffTable(true)}
    //                   >
    //                     Show
    //                   </button>
    //                 </div>
    //               </div>
    //             </div>
    //           </div>
    //         </div>

    //         {/* ================= TABLE ================= */}
    //         {showCutoffTable && (
    //           <div className="row mt-3">
    //             <div className="col-md-12">
    //               <table className="table table-bordered">
    //                 <thead className="thead-light">
    //                   <tr>
    //                     <th>Roll No</th>
    //                     <th>Candidate Name</th>
    //                     <th>Subject 1</th>
    //                     <th>Subject 2</th>
    //                     <th>Subject 3</th>
    //                     <th>Final Marks</th>
    //                   </tr>
    //                 </thead>
    //                 <tbody>
    //                   {/* API data will come here */}
    //                   <tr>
    //                     <td>101234</td>
    //                     <td>Rahul Patil</td>
    //                     <td>45</td>
    //                     <td>52</td>
    //                     <td>48</td>
    //                     <td><strong>145</strong></td>
    //                   </tr>
    //                 </tbody>
    //               </table>
    //             </div>
    //           </div>
    //         )}
    //       </>
    //     )}


    //   </div>
    // </div>

    <div className="dashboardContentArea">

      {/* <h5 className="ml-3">{commonLabels.Qualified}</h5> */}

      {/* ===== OUTER BORDER (SAME AS ApplicationPreferenceReport) ===== */}
      <div
        className="tab-content myTabContent1"
        id="myTabContentContainer"
      >

        {/* ===== TABS ===== */}
        <ul className="nav nav-tabs" role="tablist">
          <li className="nav-item">
            <a
              // href="#"
              // className={
              //   stepName === "qualifyingReport"
              //     ? "nav-link active"
              //     : "nav-link bg-profile-tabs"
              // }
              onClick={() => setStepName("qualifyingReport")}
            >
              <h5>{commonLabels.QualifyingResult}</h5>
            </a>
          </li>

          {/* <li className="nav-item">
            <a
              href="#"
              className={
                stepName === "qualifyingCutoff"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              onClick={() => setStepName("qualifyingCutoff")}
            >
              {commonLabels.QualifyingCutOff}
            </a>
          </li> */}
          {/* <li className="nav-item">
            <a
              href="#"
              className={
                stepName === "finalResult"
                  ? "nav-link active"
                  : "nav-link bg-profile-tabs"
              }
              onClick={() => setStepName("finalResult")}
            >
              Subject Result
            </a>
          </li> */}

        </ul>

        {/* ===== INNER CONTENT (SAME BORDER CONTINUES) ===== */}
        <div className="tab-content">

          {/* ================= TAB 1 : QUALIFYING REPORT ================= */}
          {stepName === "qualifyingReport" && (
            <>
              <div className="row dashboardCards">
                <div className="col-md-12">
                  <form>
                    <div className="form-group importFromSection">
                      <div className="row">

                        <div className="form-group col-md-2">
                          <label>
                            {commonLabels.selectYear}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) => onSelectYear(e.target.value)}
                          >
                            <option value="">{commonLabels.COMBO_SELECT}</option>
                            {yearList?.map((yr, i) => (
                              <option key={i}>{yr}</option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group col-md-5">
                          <label>
                            {commonLabels.SelectAdvertNo}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) =>
                              onAdvertisementChange(e.target.value)
                            }
                          >
                            <option value="">{commonLabels.COMBO_SELECT}</option>
                            {allYearList
                              ?.filter(e => e.isActive && !e.isDeleted)
                              .map((el, i) => (
                                <option key={i} value={el.id}>
                                  {`${el.advertisementNo}/${el.year} - ${el.name}`}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="form-group col-md-4">
                          <label>
                            {label.SelectExam}
                            <span className="errorText">*</span>
                          </label>
                          <select
                            className="form-control"
                            onChange={(e) => onExamChange(e.target.value)}
                          >
                            <option value="">{commonLabels.COMBO_SELECT}</option>
                            {examList
                              ?.filter(e => e.isActive && !e.isDeleted)
                              .map((el, i) => (
                                <option key={i} value={el.id}>
                                  {el.name}
                                </option>
                              ))}
                          </select>
                        </div>

                      </div>
                    </div>
                  </form>
                </div>
              </div>

              {/* ===== RESULT TABLE ===== */}
              {qualifyingCandidatesList?.advertisementNo && (
                <>
                  {(session.roleName === "superadmin" ||
                    session.roleName === "secretary") && (
                      // <div className="row">
                      //   <div className="col-md-12 text-right">
                      //     <button
                      //       className="btn btn-primary mb-2"
                      //       onClick={printQualifyingListPDF}
                      //     >
                      //       {commonLabels.BUTTON_PRINT}
                      //     </button>
                      //   </div>
                      // </div>
                      <div className="row">
                        <div className="col-md-12 text-right">

                          <button
                            className="btn btn-success mb-2 mr-2"
                            onClick={downloadExcel}
                          >
                            Download Excel
                          </button>

                          <button
                            className="btn btn-primary mb-2"
                            onClick={printQualifyingListPDF}
                          >
                            {commonLabels.BUTTON_PRINT}
                          </button>

                        </div>
                      </div>
                    )}

                  <div ref={pdfRef}>
                    {qualifyingCandidatesList?.postWiseCandidates?.map((post, postIndex) => (
                      <div
                        key={post.postCriteriaId || postIndex}
                        className="mb-4"
                      >
                        <div className="card mb-2">
                          <div className="card-header bg-light py-2">
                            <div className="row align-items-center">
                              <div className="col-md-2">
                                <strong>Post {postIndex + 1}</strong>
                              </div>
                              <div className="col-md-10">
                                <strong>{post.postName || "-"}</strong>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="table-responsive">
                          <table className="table table-bordered table-striped text-center">
                            <thead className="thead-light">
                              <tr>
                                <th style={{ width: "6%" }}>
                                  {label.SNo}
                                </th>
                                <th style={{ width: "12%" }}>
                                  {label.INTNO}
                                </th>
                                <th style={{ width: "15%" }}>
                                  Application No
                                </th>
                                <th style={{ width: "15%" }}>
                                  {label.ROLLNO}
                                </th>
                                <th style={{ width: "30%" }}>
                                  {label.CANDIDTESNAME}
                                </th>
                                <th style={{ width: "10%" }}>
                                  {label.GENDER}
                                </th>
                                <th style={{ width: "12%" }}>
                                  {label.STATUS}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {post?.qualifiedCandidates?.length > 0 ? (
                                post.qualifiedCandidates.map((candidate, candidateIndex) => (
                                  <tr
                                    key={
                                      candidate.applicationId ||
                                      `${postIndex}-${candidateIndex}`
                                    }
                                  >
                                    <td>
                                      {candidateIndex + 1}
                                    </td>
                                    <td>
                                      {candidate.interviewNo || "-"}
                                    </td>
                                    <td>
                                      {candidate.applicationId || "-"}
                                    </td>
                                    <td>
                                      {candidate.rollNo || "-"}
                                    </td>
                                    <td className="text-left">
                                      {candidate.candidateName || "-"}
                                    </td>
                                    <td>
                                      {candidate.gender || "-"}
                                    </td>
                                    <td>
                                      {candidate.status || "-"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td
                                    colSpan="7"
                                    className="text-center"
                                  >
                                    No qualified candidates found
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </>
          )}

          {/* ================= TAB 2 : QUALIFYING RESULT ================= */}
          {/* {stepName === "qualifyingCutoff" && (
            <>
              <div className="row dashboardCards">
                <div className="col-md-12">
                  <div className="form-group importFromSection"> */}
          {/* <div className="row">

                      <div className="form-group col-md-2">
                        <label>
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => onSelectYear(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {yearList?.map((yr, i) => (
                            <option key={i}>{yr}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group col-md-5">
                        <label>
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) =>
                            onAdvertisementChange(e.target.value)
                          }
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {allYearList
                            ?.filter(e => e.isActive && !e.isDeleted)
                            .map((el, i) => (
                              <option key={i} value={el.id}>
                                {`${el.advertisementNo}/${el.year} - ${el.name}`}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => setSelectedExam(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {examList
                            ?.filter(e => e.isActive && !e.isDeleted)
                            .map((el, i) => (
                              <option key={i} value={el.id}>
                                {el.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-2">
                        <label>&nbsp;</label>
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          onClick={handleShowQualified}
                        >
                          Show
                        </button>

                      </div>

                    </div> */}
          {/* <div className="row">

                      <div className="form-group col-md-2">
                        <label>
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => onSelectYear(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {yearList?.map((yr, i) => (
                            <option key={i}>{yr}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => onAdvertisementChange(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {allYearList
                            ?.filter(e => e.isActive && !e.isDeleted)
                            .map((el, i) => (
                              <option key={i} value={el.id}>
                                {`${el.advertisementNo}/${el.year} - ${el.name}`}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-2">
                        <label>
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => {
                            const examId = e.target.value;
                            setSelectedExam(examId);
                            setSelectedSubject("");

                            if (examId) {
                              dispatch(getSubjectlistByExamId(examId));
                            }
                          }}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {examList
                            ?.filter(e => e.isActive && !e.isDeleted)
                            .map((el, i) => (
                              <option key={i} value={el.id}>
                                {el.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          {label.SelectSubject}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          value={selectedSubject}
                          onChange={(e) => setSelectedSubject(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>

                          {subjectList
                            ?.filter(el => el.isActive && !el.isDeleted)
                            .map((el, index) => (
                              <option key={index} value={el.id}>
                                {el.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-2">
                        <label>&nbsp;</label>
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          onClick={handleShowQualified}
                        >
                          {commonLabels.Show}
                        </button>
                      </div>

                    </div> */}
          {/* </div> */}
          {/* </div> */}
          {/* </div> */}

          {/* {showCutoffTable && (
                <table className="table table-bordered mt-3">
                  <thead className="thead-light">
                    <tr>
                      <th>{commonLabels.RollNo}</th>
                      <th>{commonLabels.CandidateName}</th>

                      {subjectHeaders.map((sub, i) => (
                        <th key={i}>{sub}</th>
                      ))}

                      <th>{commonLabels.TotalMarks}</th>
                      <th>{commonLabels.QualifyingStatus}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {checkQualifiedList.map((row, i) => (
                      <tr key={i}>
                        <td>{row.rollNo}</td>
                        <td>{row.candidateName}</td>

                        {subjectHeaders.map((sub, idx) => (
                          <td key={idx}>
                            {row.subjectMarks?.[sub] ?? "-"}
                          </td>
                        ))}

                        <td><strong>{row.totalMarks}</strong></td>
                        <td>
                          {row.qualified ? (
                            <span className="text-success fw-bold">{commonLabels.Qualified}</span>
                          ) : (
                            <span className="text-danger fw-bold">{commonLabels.NotQualified}</span>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              )} */}

          {/* </> */}
          {/* )} */}

          {/* ================= TAB 3 : FINAL RESULT ================= */}
          {/* {stepName === "finalResult" && (
            <>
              <div className="row dashboardCards">
                <div className="col-md-12">
                  <div className="form-group importFromSection">
                    <div className="row">
                      <div className="form-group col-md-2">
                        <label>
                          {commonLabels.selectYear}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => onSelectYear(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {yearList?.map((yr, i) => (
                            <option key={i}>{yr}</option>
                          ))}
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          {commonLabels.SelectAdvertNo}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => onAdvertisementChange(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {allYearList
                            ?.filter(e => e.isActive && !e.isDeleted)
                            .map((el, i) => (
                              <option key={i} value={el.id}>
                                {`${el.advertisementNo}/${el.year} - ${el.name}`}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-3">
                        <label>
                          {label.SelectExam}
                          <span className="errorText">*</span>
                        </label>
                        <select
                          className="form-control"
                          onChange={(e) => setSelectedExam(e.target.value)}
                        >
                          <option value="">{commonLabels.COMBO_SELECT}</option>
                          {examList
                            ?.filter(e => e.isActive && !e.isDeleted)
                            .map((el, i) => (
                              <option key={i} value={el.id}>
                                {el.name}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="form-group col-md-2">
                        <label>Status</label>
                        <select
                          className="form-control"
                          value={selectedFinalStatus}
                          onChange={(e) => setSelectedFinalStatus(e.target.value)}
                        >
                          <option value="">Select</option>
                          <option value="pass">Pass</option>
                          <option value="fail">Fail</option>
                        </select>
                      </div>

                      <div className="form-group col-md-2">
                        <label>&nbsp;</label>
                        <button
                          type="button"
                          className="btn btn-primary w-100"
                          onClick={handleShowFinalResult}
                        >
                          Show
                        </button>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

              {showFinalTable && (
                <table className="table table-bordered mt-3">
                  <thead className="thead-light">
                    <tr>
                      <th>S.No</th>
                      <th>Roll No</th>
                      <th>Candidate Name</th>
                      <th>Marks</th>
                      <th>Gender</th>
                      <th>Category</th>
                      <th>Status</th>
                    </tr>
                  </thead>

                  <tbody>
                    {finalResultData?.candidates?.map((row, i) => (
                      <tr key={i}>
                        <td className="text-center">{i + 1}</td>
                        <td className="text-center">{row.rollNo}</td>
                        <td>{row.name}</td>
                        <td className="text-center"><strong>{row.marks}</strong></td>
                        <td className="text-center">{row.gender}</td>
                        <td className="text-center">{row.category}</td>
                        <td className="text-center">
                          {row.status === "Pass" ? (
                            <span className="text-success fw-bold">Pass</span>
                          ) : (
                            <span className="text-danger fw-bold">Fail</span>
                          )}
                        </td>
                      </tr>
                    ))}

                  </tbody>
                </table>
              )}
            </>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default QualifyingReports;
